<template>
  <div class="avatar">
    <AppGalleryItem
      v-if="photo"
      :photo="photo"
    />

    <div
      v-else
      class="placeholder"
    >
      <div class="inner">
        <div class="inner2">
          <img src="/images/placeholder.svg" class="photo">
        </div>
      </div>
    </div>

    <div
      class="upload"
      @click="onUpload"
    >
      <input
        accept="image/jpeg,image/png"
        type="file"
        ref="fileInput"
        hidden
        @change="onFile"
      >

      <BaseIcon
        icon="camera"
        class="upload__icon"
      />

      <p class="upload__text">Изменить фотографию</p>
    </div>

    <div
      v-if="photo"
      class="close"
      @click="onDelete"
    >
      <span>&#10006;</span>
    </div>
  </div>
</template>

<script>
import AppGalleryItem from '@/components/AppGalleryItem'
import BaseIcon from '@/components/Base/BaseIcon'

export default {
  name: 'AppAvatar',
  components: {
    BaseIcon,
    AppGalleryItem
  },
  props: {
    photo: {
      type: String,
      default: ''
    }
  },
  methods: {
    onUpload () {
      this.$refs.fileInput.click()
    },
    onFile (event) {
      this.$emit('file', event.target.files[0])
      event.target.value = ''
    },
    onDelete () {
      this.$emit('delete')
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar {
  position: relative;
  overflow: hidden;

  &:hover {
    .upload {
      bottom: 0;
    }

    .close {
      top: 6px;
      right: 6px;
    }
  }

  .placeholder {
    position: relative;

    .inner {
      padding-bottom: 100%;
      width: 100%;

      .inner2 {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .upload {
    padding: 0 10px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: -50px;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(40px);
    user-select: none;
    cursor: pointer;
    transition: .2s;

    &__icon {
      width: 20px;
    }

    &__text {
      margin-left: 10px;
    }
  }

  .close {
    position: absolute;
    top: -36px;
    right: -36px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 1000px;
    color: $brand-color;
    cursor: pointer;
    user-select: none;
    transition: .2s;
  }
}
</style>
